export default "__VITE_ASSET__D6H8o56l__"